import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { getAutosuggestQuery as getAutosuggestQueryHelper } from '@Components/AutosuggestInput/AutosuggestInputHelper';

const withInputOnChangeHOCGenerator = (Component) => {
  function WithInputOnChangeHOC(props) {
    const { stopWords, minSymbolsToStart, value, setValue, setQuery } = props;
    const inputOnChange = useCallback(
      (inputValue) => {
        if (inputValue === value) {
          return;
        }

        const query = getAutosuggestQueryHelper({
          string: inputValue,
          stopWords,
          minSymbolsToStart,
        });

        setValue(inputValue);
        setQuery(query);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [value]
    );
    return <Component {...props} inputOnChange={inputOnChange} />;
  }

  WithInputOnChangeHOC.propTypes = {
    stopWords: PropTypes.arrayOf(PropTypes.string),
    minSymbolsToStart: PropTypes.number,
    value: PropTypes.string,
    setValue: PropTypes.func,
    setQuery: PropTypes.func,
  };

  return WithInputOnChangeHOC;
};

const withInputOnChange = () => (Component) => withInputOnChangeHOCGenerator(Component);

export default withInputOnChange;
